function init() {
    var url = '/Handler/Favorite';
    var uid = 0;
    $('#option-fav a').click(function(event) {
        var $el = $(this);
        var option = $el.attr('class');

        var data = {
            type: option,
            pageid: $el.attr('data-pageid'),
            uid: $el.attr('data-uid')
        };
        $.ajax({
            cache: false,
            type: "POST",
            url: url,
            data: {
                data: data
            }
        }).done(function(data) {
            if (data == 'ok') {
                if (option == 'fav-add') {
                    $el.html('Favorite entfernen');
                    $el.removeClass('fav-add').addClass('fav-del');
                    $el.prev().removeClass('icon-fav-off').addClass('icon-fav-on');
                } else {
                    $el.html('Zu Favoriten hinzu fügen');
                    $el.removeClass('fav-del').addClass('fav-add');
                    $el.prev().removeClass('icon-fav-on').addClass('icon-fav-off');
                }
            }
        });

        return false;
    });
    // Dialog für externen Favoriten
    var dlg_addFav = $("#dlg_addFav").dialog({
        autoOpen: false,
        modal: true,
        width: 460,
        title: "Favoriten",
        height: 180,
        maxHeight: 540,
        buttons: [{
            text: 'Ok',
            class: 'ok',
            click: function() {
                if (!$('#urlFav').val().match(/^\//) && !$('#urlFav').val().match(/^http/)) {
                    $('#urlFav').val('https://' + $('#urlFav').val());
                }
                document.body.style.cursor = 'wait';
                var loader = document.getElementById('loader');
                $.ajax({
                    cache: false,
                    type: "POST",
                    url: url,
                    data: {
                        data: {
                            type: 'fav-extern',
                            uid: uid,
                            url: $('#urlFav').val(),
                            title: $('#titleFav').val(),
                            id: $('#idFav').val()
                        }
                    }
                }).done(function(data) {
                    if (data === 'ok') {
                        loader.querySelector('.content p').innerHTML = 'Bitte warten';
                        loader.style.display = 'block';
                        window.setTimeout(function() {
                            location.reload();
                        }, 200);
                    }
                    if (data === 'update') {
                        document.body.style.cursor = 'default';
                        dlg_addFav.row.text($('#titleFav').val());
                        dlg_addFav.row[0].href = $('#urlFav').val();
                        dlg_addFav.dialog("close");
                    }
                });
            }
        }, {
            text: 'Abbrechen',
            class: 'cancel',
            click: function() {
                $(this).dialog("close");
            }
        }]
    });
    $('.addFavorite').on('click', function(event) {
        uid = $(this).attr('data-uid');
        dlg_addFav[0].querySelector('#idFav').value = '';
        dlg_addFav[0].querySelector('#titleFav').value = '';
        dlg_addFav[0].querySelector('#urlFav').value = '';
        dlg_addFav.dialog("open");
    });

    $('.fav-edit').on('click', function(ev) {
        var a = ($(this).closest('.fav-item').find('a'));
        dlg_addFav.row = a;
        $(dlg_addFav).find('#idFav').val($(this).attr('data-id'));
        $(dlg_addFav).find('#titleFav').val(a.text());
        $(dlg_addFav).find('#urlFav').val(a[0].getAttribute('href'));
        dlg_addFav.dialog("open");
    });

    $('.list.favorites .icon-trash').on('click', function(event) {
        var $el = $(this);
        var data = {
            type: 'fav-del',
            pageid: $el.attr('data-pageid'),
            uid: $el.attr('data-uid')
        };
        if ($el.attr('data-id')) {
            data = {
                type: 'fav-del',
                id: $el.attr('data-id'),
                uid: $el.attr('data-uid')
            };
        }

        $.ajax({
            cache: false,
            type: "POST",
            url: url,
            data: {
                data: data
            }
        }).done(function(data) {
            $el.closest('.fav-item').remove();
        });
    });
}
init();
